<button
    class="scroll-to-top"
    [class.visible]="isVisible"
    (click)="scrollToTop()"
    aria-label="Scroll to top"
>
    <i class="fas fa-angle-double-up"></i>
</button>